// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__UTWlp","signatureBlock":"Footer_signatureBlock__Fqg5C","signature":"Footer_signature__xORjw"};